import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-send_backward",
  "use": "icon-send_backward-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-send_backward\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M14,11h4v1H14Zm-3,0H7v1h4ZM7,7v3h5v5.6L10.38,14l-.71.71,2.83,2.83,2.83-2.83L14.62,14,13,15.6V10h5V7Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol